import script from "./CreateEditAcadmy.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEditAcadmy.vue?vue&type=script&setup=true&lang=js"

import "./CreateEditAcadmy.vue?vue&type=style&index=0&id=6d9662e2&lang=scss"

const __exports__ = script;

export default __exports__